import { render, staticRenderFns } from "./section7.vue?vue&type=template&id=27e7201f&scoped=true"
import script from "./section7.vue?vue&type=script&lang=js"
export * from "./section7.vue?vue&type=script&lang=js"
import style0 from "./section7.vue?vue&type=style&index=0&id=27e7201f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7201f",
  null
  
)

export default component.exports